export default class CampaignSendBehaviorDomainService {
    static get SendOnStart() {
        return {
            id: 1,
            name: "Immediate",
        };
    }
    static get SendOnDate() {
        return {
            id: 2,
            name: "Scheduled",
        };
    }
    static get SendOngoing() {
        return {
            id: 3,
            name: "Scheduled - Ongoing",
        };
    }
    static get Behaviors() {
        return {
            SendOnStart: CampaignSendBehaviorDomainService.SendOnStart,
            SendOnDate: CampaignSendBehaviorDomainService.SendOnDate,
            SendOngoing: CampaignSendBehaviorDomainService.SendOngoing,
        };
    }
    static fromJSON(json) {
        switch (json.name) {
            case "SendOnStart":
                return CampaignSendBehaviorDomainService.SendOnStart;
            case "SendOnDate":
                return CampaignSendBehaviorDomainService.SendOnDate;
            case "SendOngoing":
                return CampaignSendBehaviorDomainService.SendOngoing;
            default:
                return null;
        }
    }
}
